import React from 'react';
import Banner from '../components/Banner';
import AboutCollege from '../components/AboutCollege';
import AdmissionSection from '../components/Admission';
import CoursesSection from '../components/CoursesSection';
import ContactSection from '../components/ContactSection';

function Home() {
  return (
    <>
      <Banner />
      <AboutCollege />
      <AdmissionSection/>
      <CoursesSection />
      <ContactSection />
    </>
  );
}

export default Home;